export default "__VITE_ASSET__413e5bc9__"